<template>
  <section class="getGrowth">
    <div class="top_bg">
        <div v-if="!ars.awardName">
            <div class="done_title" v-if="detail.status < 40 && !detail.marketingCampaignStatus">活动已过期</div>

            <div v-if="detail.status < 40 && !detail.marketingCampaignStatus">
                <img src="/images/growth/sorry.png" class="top_img" />
            </div>

            <div v-if="detail.status < 40 && detail.marketingCampaignStatus">
                <img src="/images/growth/top_img.png" class="top_img" />
            </div>

            <div class="item_content" v-if="!ars.awardName">
                <div class="item" v-for="(item,index) in list" @click="changeRadio(item.id,index)">
                <div class="item_check">
                    <div class="radio_content">
                    <radio :disabled="!item.available" :checked="checkId == item.id" @changeRadio="changeRadio(item.id,index)" />
                    </div>
                    <img :src="item.pic | formatImgUrl(200,200,true)" class="goods_img" />
                    <div v-if="!item.available" class="nogoods-show">
                        <span style="color:#fff"> 抢光啦</span>
                    </div>
                </div>
                <div class="item_dero">
                    <div class="title" v-if="item.available">
                      <span>
                        {{item.ruleName}}
                      </span>
                    </div>
                    <div class="title" v-if="!item.available" style="color:#b5b5b5">
                      <span>
                        {{item.ruleName}}
                      </span>
                      </div>
                    <!-- <div class='dero'>{{item.descr}}</div> -->
                </div>
                </div>
                <div class="btn_content mt64">
                <button class="primary mybtn" @click="submitApply()">立即领取</button>
                </div>
            </div>
        </div>
      

      <div v-if="ars.awardName">
        <div class="done_title">恭喜你</div>

        <!-- <div class='done_title font_size'  v-if='detail.status >= 40 && $store.state.customerId != detail.customerId'>
                很抱歉，礼品已被领取
        </div>-->

        <div class="done_dero" v-if="ars">获得了{{ars.awardName}}</div>

        <div class="view_content" v-if="ars">
          <img
            :src='"https://baozheng-front-new.baozheng.cc/" + ars.awardPic'
            class="get_img"
          />
          <div class="btn_content mt64">
            <button class="primary mybtn mt80" @click="backGift">回到我参与的团</button>
          </div>
          <div class="btn_content" v-if="$store.state.customerId == detail.customerId">
            <button class="primary mybtn mt30" @click="toLook">查看礼品</button>
          </div>
        </div>
      </div>

      <div class="btn_content mt64" v-if="detail.status < 40 && !detail.marketingCampaignStatus">
        <button class="primary mybtn mt80" @click="$router.push({name:"homeIndex"})">回到首页</button>
      </div>
    </div>
    <div class='contentItem'>
       <h3 class="f28 bold">礼品说明</h3>
        <h2><p style="margin-top:0px;margin-bottom:0px;text-rendering:optimizelegibility;font-feature-settings:&quot;kern&quot;;font-kerning:normal;color:#333333;font-family:ArialMT, Arial, sans-serif;font-size:13px;white-space:normal;">1<span style="font-family:PingFangSC-Regular, &quot;PingFang SC&quot;, sans-serif;">、</span>50<span style="font-family:PingFangSC-Regular, &quot;PingFang SC&quot;, sans-serif;">元包拯养护代金券立刻到帐，可在我的优惠券中查看，有效期至</span>10.20 24:00<span style="font-family:PingFangSC-Regular, &quot;PingFang SC&quot;, sans-serif;">，还请尽快使用。</span></p><p style="margin-top:0px;margin-bottom:0px;text-rendering:optimizelegibility;font-feature-settings:&quot;kern&quot;;font-kerning:normal;color:#333333;font-family:ArialMT, Arial, sans-serif;font-size:13px;white-space:normal;">2<span style="font-family:PingFangSC-Regular, &quot;PingFang SC&quot;, sans-serif;">、</span>LV<span style="font-family:PingFangSC-Regular, &quot;PingFang SC&quot;, sans-serif;">旧包改造小物因种类较多，请先根据自己的喜好和实际情况进行选择，锁定礼品。</span></p><p style="margin-top:0px;margin-bottom:0px;text-rendering:optimizelegibility;font-feature-settings:&quot;kern&quot;;font-kerning:normal;color:#333333;font-family:ArialMT, Arial, sans-serif;font-size:13px;white-space:normal;"><span style="font-family:PingFangSC-Regular, &quot;PingFang SC&quot;, sans-serif;">3、在养护时使用本次活动的50元券，即可获得选择的礼品。</span></p><p style="margin-top:0px;margin-bottom:0px;text-rendering:optimizelegibility;font-feature-settings:&quot;kern&quot;;font-kerning:normal;color:#333333;font-family:ArialMT, Arial, sans-serif;font-size:13px;white-space:normal;"><span style="font-family:PingFangSC-Regular, &quot;PingFang SC&quot;, sans-serif;">4、礼品随养护的包包一起寄回。</span></p><p style="margin-top:0px;margin-bottom:0px;text-rendering:optimizelegibility;font-feature-settings:&quot;kern&quot;;font-kerning:normal;color:#333333;font-family:ArialMT, Arial, sans-serif;font-size:13px;white-space:normal;">5<span style="font-family:PingFangSC-Regular, &quot;PingFang SC&quot;, sans-serif;">、礼品的领取资格保留至 10.20 24:00，若在此之前还未用券进行养护，则视为放弃礼品。</span></p><p style="margin-top:0px;margin-bottom:0px;text-rendering:optimizelegibility;font-feature-settings:&quot;kern&quot;;font-kerning:normal;color:#333333;font-family:ArialMT, Arial, sans-serif;font-size:13px;white-space:normal;"><span style="font-family:PingFangSC-Regular, &quot;PingFang SC&quot;, sans-serif;">6、本次礼品为真包改造，纯手工制作，不能折现、无法退换。</span></p></h2>
    </div>
  </section>
</template>

<script>
import growthBottom from "./growthBottom";
import homeApi from "@/axios/home";
import { Dialog, Toast } from "vant";
import wxShare from "@/assets/js/wx.share";
export default {
  name: "growth",
  data() {
    return {
      adrShow: false,
      ars: {
          awardName:null
      },
      detail: {
        status: 10,
        giftBagList: [],
        marketingCampaignStatus: 1
      },
      checkId: "",
      activeIndex: "",
      adrList: [],
      list: [],
      getGoods: {},
    };
  },
  components: {
    growthBottom: growthBottom
  },
  watch: {},
  computed: {
    groupActivityId() {
      return this.$route.query.groupActivityId;
    },
    groupActivityRecordId() {
      return this.$route.query.groupActivityRecordId;
    }
  },
  created() {
    this.getList();
  },
  mounted() {
    this.getGift();
  },
  methods: {
    backGift() {
      let res = this.ars;
      this.$router.push({
        name: "teamDetail",
        query: {
          groupRecordId: res.groupActivityRecordId,
          orderCode: res.orderCode
        }
      });
    },
    getGift() {
      homeApi
        .groupHisActivity({ groupActivityId: this.groupActivityId })
        .then(res => {
          this.ars = res;
        });
    },
    submitApply() {
      if (!this.checkId) {
        Toast("请选择一个礼品哦亲~");
        return;
      }
      //需要判断领取的是否需要选择地址
      // let goods = this.detail.giftBagList[this.activeIndex];
      let params ={}
      params.awardRuleId = this.checkId;
      params.groupActivityId = this.groupActivityId;
      params.groupActivityRecordId = this.groupActivityRecordId;
      homeApi.getAwardGoods(params).then(res => {
        //领取成功
        Toast("领取成功");
         this.$router.go(0);
      }).catch(()=>{
          this.$router.go(0);
      });
    },
    changeRadio(id, index) {
      this.checkId = id;
      this.activeIndex = index;
    },
    // getGoods() {
    //   let { groupActivityId } = this;
    //   homeApi.getAwardGoods({ groupActivityId }).then(res => {
    //     this.list = res;
    //   });
    // },
    getList() {
      let { groupActivityId } = this;
      homeApi.getAward({ groupActivityId }).then(res => {
        this.list = res;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.font_size {
  font-size: 36px !important;
}
.mt80 {
  margin-top: 80px !important;
}
.mt30 {
  margin-top: 30px !important;
}
.get_img {
  width: 100%;
  margin-top: 40px;
}
.done_title {
  text-align: center;
  font-size: 60px;
  font-family: PingFangSC-Medium, PingFang SC;
  font-weight: 500;
  color: rgba(223, 88, 103, 1);
}
.done_dero {
  color: #333;
  font-size: 32px;
  text-align: center;
  margin-top: 10px;
}
.item_dero {
  margin-left: 70px;
}
.title {
  color: #3f3f3f;
  font-size: 40px;
  font-weight: 600;
  margin-top: 60px;
}
.dero {
  font-weight: 400;
  font-size: 24px;
  margin-top: 25px;
}
.goods_img {
  width: 164px;
  height: 164px;
  border-radius: 50%;
  margin-left: 22px;
  border: 2px solid #7edade;
}
.item_check {
  display: flex;
  align-items: center;
}
.radio_content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 20px;
  height: 232px;
}
.select {
  width: 32px;
  flex: none;
  display: flex;
  justify-content: center;
  align-items: center;
  .van-checkbox {
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.top_bg {
  background: url("/images/growth/top_bg.png") no-repeat;
  background-size: 100%;

  padding-right: 40px;
  padding-left: 40px;
  padding-bottom: 100px;
  padding-top: 40px;
  .top_img {
    width: 100%;
    margin-top: 44px;
  }
  .item_content {
    padding: 0 20px;
    .item {
      width: 100%;
      height: 232px;
      background: url("/images/growth/item_bg.png") no-repeat center center;
      background-size: 100%;
      margin: 35px 0;
      display: flex;
    }
  }
}
.mybtn {
  width: 100%;
  margin-top: 10px;
}

.containerAdr {
  height: 860px;
  padding: 32px;
  position: relative;
  padding-bottom: 60px;
  padding-top: 0px;
  .title {
    line-height: 90px;
    border-bottom: 1px solid #eeeeee;
    font-size: 28px;
    font-weight: 500;
  }
  & > span {
    position: absolute;
    right: 30px;
    top: 80px;
    color: #7adfdf;
  }
  .addr-container {
    height: 700px;
    overflow-y: scroll;
    ul li {
      width: 100%;
      display: flex;
      padding-top: 32px;

      // align-items: center;
    }
  }
  .close {
    width: 36px;
    height: 36px;
    position: absolute;
    top: 30px;
    right: 30px;
    background: url("/images/public/close.png") no-repeat center;
    background-size: 32px;
  }
  .secondary {
    position: absolute;
    bottom: 27px;
    right: 270px;
  }

  .submit {
    position: absolute;
    bottom: 20px;
    right: 30px;
  }
}
.nogoods-show{
    width:168px;
    height:168px;
    background-color: #00000080;
    position: absolute;
    margin-left: 76px;
    line-height: 168px;
    text-align: center;
}
pre { // 兼容多个浏览器
    white-space: pre-wrap;
    white-space: -moz-pre-wrap;
    white-space: -pre-wrap;
    white-space: -o-pre-wrap;
    *word-wrap: break-word;
    *white-space : normal ;
}
.contentItem {
  padding: 40px;
  line-height: 40px;
  h3 {
    margin-bottom: 40px;
    line-height: 40px;
    position: relative;
    &::after {
      content: "";
      width: 8px;
      height: 24px;
      background: $primary-color;
      position: absolute;
      left: -12px;
      top: 6px;
    }
  }
}
</style>
